import { render, staticRenderFns } from "./TicketAssigned.vue?vue&type=template&id=b719f838&scoped=true"
import script from "./TicketAssigned.vue?vue&type=script&lang=js"
export * from "./TicketAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b719f838",
  null
  
)

export default component.exports